import {alias, createModelSchema, custom, deserialize, list, serialize, SKIP} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";
import {ProductModel} from "@/modules/redactor/models/product/ProductModel";

export class MultiTabStageModel extends Cloneable {

    static schema() {
        return custom((v) => {
            return v && !v.empty() ? serialize(MultiTabStageModel, v) : SKIP;
        }, (v) => {
            return deserialize(MultiTabStageModel, v);
        });
    }

    constructor() {
        super();

        this._id = 0;
        this._key = null;
        this._discount = 0;
        this._products = [];
    }

    get id() {
        return this._id;
    }

    set id(value) {
        this._id = value;
    }

    get key() {
        return this._key;
    }

    set key(value) {
        this._key = value;
    }

    get discount() {
        return this._discount;
    }

    set discount(value) {
        this._discount = value;
    }

    get products() {
        return this._products;
    }

    set products(value) {
        this._products = value;
    }

    valid() {
        if (!Number.isInteger(this.id) || this.id < 0) {
            return false;
        }

        if (!Number.isInteger(this.discount) || this.discount < 0) {
            return false;
        }

        if (!this.products || this.products.some(v => !v || !v.valid())) {
            return false;
        }

        return true;
    }

    empty() {
        return this.products.length === 0;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new MultiTabStageModel());
        } else if (target instanceof MultiTabStageModel) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(MultiTabStageModel, {
    _id: alias("id", Schema.primitive()),
    _key: alias("key", Schema.primitive()),
    _discount: alias("discount", Schema.primitive()),
    _products: alias("products", list(ProductModel.schema()))
});